import '../../src/app/scss/research_areas.scss'

setTimeout(() => {
  $('.selectors div').on('click', function() {
    var tab_id = $(this).attr('data-tab');

    $('.selectors div').removeClass('current');
    $('.research__section .content').removeClass('current');

    $(this).addClass('current');
    $("#" + tab_id).addClass('current');

  });

  $('.bullets li').on({
    'mouseenter':function(){
        $('#'+$(this).data('id')).fadeIn('fast');
    },'mouseleave':function(){
        $('#'+$(this).data('id')).fadeOut('fast');
    }
  });
}, 2000);